import { Box, IconButton, Tooltip } from '@mui/material';
import BrushIcon from '@mui/icons-material/Brush';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from 'react';
import MessageModal from '../message-modal/MessageModal';
import { useTranslation } from 'react-i18next';
import { USER_PERMISSIONS } from '../constants/permissions';
import { useCheckPermission } from '../hooks/useCheckPermission';

interface EditButtonsRowProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const EditButtonsRow = ({ onEdit, onDelete }: EditButtonsRowProps) => {
  const { t } = useTranslation();
  const [deleteMessageModalOpen, setDeleteMessageModalOpen] = useState(false);
  const checkPermission = useCheckPermission();
  return (
    <Box>
      {deleteMessageModalOpen && (
        <MessageModal
          open={deleteMessageModalOpen}
          modalTitle={t('messages.deleteContact')}
          modalMessage={t('messages.deleteBusinessContactDialog')}
          actionButtonText={t('buttons.goBack')}
          actionButtonFn={() => setDeleteMessageModalOpen(false)}
          goBackButtonText={t('buttons.delete')}
          onClose={() => {
            onDelete();
          }}
        />
      )}
      <Tooltip
        title={
          checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_UPDATE_CONTACT)
            ? t('buttons.edit')
            : t('messages.contactAdministrator')
        }
        arrow
        placement='top'
      >
        <IconButton
          disabled={!checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_UPDATE_CONTACT)}
          onClick={() => {
            onEdit();
          }}
        >
          <BrushIcon />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={
          checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_DELETE_CONTACT)
            ? t('buttons.delete')
            : t('messages.contactAdministrator')
        }
        arrow
        placement='top'
      >
        <IconButton
          disabled={!checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_DELETE_CONTACT)}
          onClick={() => {
            setDeleteMessageModalOpen(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
